<template>
  <va-card stripe="primary">
    <SwappingSquaresSpinner v-if="loadingHandle"
      :animation-duration="1000"
      :size="90"
      :color="this.$store.getters.config.palette.primary"
      style="margin: 30px auto;"
    />
    <div class="va-card__body" v-if="!loadingHandle">
      <form style="margin-top: 20px;">
        <div class="row">
          <va-input
            v-model="appSubscription.name"
            type="text"
            :label="$t('subscriptions.name')"
            class="flex xs12"
            :error="!!subscriptionNameErrors.length"
            :error-messages="subscriptionNameErrors"
          />

          <va-input
            v-model="appSubscription.description"
            type="text"
            :label="$t('subscriptions.description')"
            class="flex xs12"
          />
        </div>
        <div class="row" style="padding-left: 10px; margin-bottom: 10px;">
          <fieldset class="xs12">
            <va-checkbox
              :label="$t('subscriptions.requestTip')"
              v-model="appSubscription.isRequestTip"
            />
          </fieldset>
          <fieldset class="xs12" style="width: 100%;">
            <va-checkbox
              :label="$t('subscriptions.defaultSubscription')"
              v-model="appSubscription.isDefault"
            />
          </fieldset>
          <fieldset class="xs12" style="width: 100%;">
            <va-checkbox
              :label="$t('subscriptions.showThisPlan')"
              v-model="appSubscription.isGlobal"
            />
          </fieldset>
        </div>
        <div class="row">
          <div class="flex xs12">
            <va-select
              :disabled="locations.length < 1 || appSubscription.isGlobal"
              :label="appSubscription.isGlobal ? $t('subscriptions.selectLocations') : $t('subscriptions.selectLocationsRequired')"
              v-model="selectedLocations"
              :placeholder="locations.length < 1 ? $t('subscriptions.noLocation') : $t('subscriptions.multipleLocationSelect')"
              multiple
              searchable
              textBy="name"
              keyBy="eventId"
              :options="locations"
              :error="!!locationErrors.length"
            />
          </div>
        </div>
        <div class="d-flex justify--center mt-3">
          <va-button @click.prevent="onsubmit()" class="my-0">{{ $t('subscriptions.update') }}</va-button>
        </div>
      </form>
    </div>
  </va-card>
</template>

<script>
import { SwappingSquaresSpinner } from 'epic-spinners'
import errorHandlerMixin from '@/mixin/errorHandlerMixin'

export default {
  name: 'FreeAppSubscription',
  components: { SwappingSquaresSpinner },
  mixins: [errorHandlerMixin],
  data () {
    return {
      appSubscription: {
        name: '',
        description: '',
        appSubscriptionTypeId: undefined,
        isWithoutPrice: true,
        isGlobal: false,
        isDefault: false,
        isUserShow: false,
        isPeriod: false,
        isPerUnit: false,
        isFixPrice: false,
        isRequestTip: false,
        appSubscriptionPrices: [],
        eventIds: [],
        overwriters: [],
        appPaymentMethodTypes: [],
      },
      locations: [],
      paymentMethods: [],
      selectedLocations: [],
      subscriptionNameErrors: [],
      locationErrors: [],
      loadingHandle: true,
    }
  },
  props: {
    appSubscriptionObj: Object,
  },
  methods: {
    async parseSubscription () {
      const subscription = {
        name: this.appSubscription.name,
        description: this.appSubscription.description,
        isWithoutPrice: this.appSubscription.isWithoutPrice,
        isGlobal: this.appSubscription.isGlobal,
        isDefault: this.appSubscription.isDefault,
        isUserShow: this.appSubscription.isUserShow,
        isPeriod: this.appSubscription.isPeriod,
        isPerUnit: this.appSubscription.isPerUnit,
        isFixPrice: this.appSubscription.isFixPrice,
        isTipRequest: this.appSubscription.isRequestTip,
        appSubscriptionPrices: [],
        appSubscriptionTypeId: 7,
        eventIds: [],
        overwriters: [],
        appPaymentMethodTypes: [],
        removedPrices: [],
      }
      this.selectedLocations.forEach(item => {
        subscription.eventIds.push(item.eventId)
      })
      return subscription
    },
    async onsubmit () {
      this.modalLoader = true
      this.subscriptionNameErrors = this.appSubscription.name ? [] : [this.$t('subscriptions.subscriptionNameError')]
      if (!this.appSubscription.isGlobal) {
        this.locationErrors = this.selectedLocations.length ? [] : [this.$t('subscriptions.locationError')]
      }
      if (!this.formSubscriptionReady) {
        return
      }
      const subscriptions = await this.parseSubscription()
      if (!subscriptions) {
        return
      }
      this.loadingHandle = true
      this.$store.dispatch('updateAppSubscription', {
        appSubscriptionId: this.appSubscriptionObj.appSubscriptionId,
        message: subscriptions,
      }).then(() => {
        this.loadingHandle = false
      }).catch(error => {
        this.errorHandler(error.response)
        this.loadingHandle = false
      })
    },
    async getTheLocations () {
      await this.$store.dispatch('getLocations')
        .then(resp => this.initlocations())
        .catch(error => {
          this.errorHandler(error.response)
          this.loadingHandle = false
        })
    },
    initlocations () {
      this.locations.splice(0, this.locations.length, ...this.$store.getters.locations)
    },
    async initAppSubscriptionRequirements () {
      this.loaderHandle(true)
      await this.$store.dispatch('getLocations')
        .then(resp => this.initlocations())
        .catch(error => {
          this.errorHandler(error.response)
          this.loadingHandle = false
        })
    },
    async initAppSubscription (appSubscription) {
      appSubscription.events.forEach(item => {
        this.locations.filter(loc => {
          if (loc.eventId === item.eventId) {
            this.selectedLocations.push(item)
          }
        })
      })
      this.appSubscription.name = appSubscription.name
      this.appSubscription.description = appSubscription.description
      this.appSubscription.appSubscriptionTypeId = appSubscription.appSubscriptionTypeId
      this.appSubscription.isWithoutPrice = appSubscription.isWithoutPrice
      this.appSubscription.isGlobal = appSubscription.isGlobal
      this.appSubscription.isDefault = appSubscription.isDefault
      this.appSubscription.isUserShow = appSubscription.isUserShow
      this.appSubscription.isPeriod = appSubscription.isPeriod
      this.appSubscription.isPerUnit = appSubscription.isPerUnit
      this.appSubscription.isFixPrice = appSubscription.isFixPrice
      this.appSubscription.isRequestTip = appSubscription.isRequestTip

      this.loadingHandle = false
    },
    loaderHandle (state) {
      this.$root.$emit('handle-loader', state)
    },
  },
  computed: {
    formSubscriptionReady () {
      return !(this.subscriptionNameErrors.length || this.locationErrors.length)
    },
  },
  mounted () {
    this.initAppSubscriptionRequirements().then(() => this.initAppSubscription(this.appSubscriptionObj))
      .catch(error => {
        this.errorHandler(error.response)
        this.loadingHandle = false
      })
  },
}
</script>

<style scoped>

</style>
